import { createFileRoute } from '@tanstack/react-router';

import { Seo } from '@/common/components/seo';
import { requireAuth } from '@/shared/auth';
import { UsersList } from '@/users/pages/users-list';

export const Route = createFileRoute('/users/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: UsersRoute
});

function UsersRoute() {
  return (
    <>
      <Seo title="Users" />
      <UsersList />
    </>
  );
}
